import { createContext, type ReactNode, useContext } from 'react';

import type { AppConfig } from './schema';

const ConfigContext = createContext<AppConfig | null>(null);

export type ConfigProviderProps = { config: AppConfig; children: ReactNode };

export const ConfigProvider = ({ config, children }: ConfigProviderProps) => (
  <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
);

export const useConfig = (): AppConfig => {
  const config = useContext(ConfigContext);
  if (config === null) {
    throw new Error('useConfig must be used inside <ConfigProvider>');
  }
  return config;
};
